export const doNothing = (): void => undefined
